export default "__VITE_ASSET__DoIakfb7__"